import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=2720fd1a&scoped=true&"
import script from "./MaterialCard.vue?vue&type=script&lang=js&"
export * from "./MaterialCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=2720fd1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720fd1a",
  null
  
)

export default component.exports